import React from "react";
import {Title} from "../../../../../../stories/Title/Title";
import {Label} from "../../../../../../stories/Label/Label";
import Input from "../../../../../../stories/Input/Input";
import {
  FormAutocomplete,
  formClasses,
} from "../../../../../../styles/AutocompleteStyles";
import {FormControlLabel, TextField} from "@mui/material";
import {AntSwitch} from "../../../../../../styles/Switch";
import {tableHeaderForm} from "../../../../../../utils/formTypes";
import {DataTypes, Operation} from "../../../../../../utils/Enum.types";
import {toStandardCase} from "../../../../../../utils/UtilFunctions";
import {Keys} from "../../../../../../utils/Enum.keys";

interface States {
  formData: tableHeaderForm;
  setFormData: React.Dispatch<React.SetStateAction<tableHeaderForm>>;
}
interface Props {
  formState: States;
  operation: Operation;
}
const Add = ({formState, operation}: Props) => {
  const {formData, setFormData} = formState;

  const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {name, value} = e.target as HTMLInputElement;

    setFormData(() => ({
      ...formData,
      [name]: value,
    }));
  };

  return (
    <>
      <Title variant="subtitle1">
        {operation === Operation.CREATE ? "Add" : "Update"} New Dynamic Field
      </Title>
      <div className="label-grid">
        <Label>Enter Table Header</Label>
        <Input
          name="header"
          value={formData.header}
          onChange={handleValueChange}
          autoFocus
          onKeyDown={(e: React.KeyboardEvent<Element>) => {
            if (e.key === Keys.ENTER) {
              e.preventDefault();

              const input = document.getElementsByClassName(
                "MuiOutlinedInput-input"
              );
              if (input.length) {
                (input[1] as HTMLInputElement).focus();
              }
            }
          }}
        />
        <Label>Data Type</Label>
        <FormAutocomplete
          className={formClasses.inputRoot}
          options={Object.values(DataTypes)}
          getOptionLabel={(option) => toStandardCase(option as string)}
          onKeyDown={(e) => {
            if (e.key === Keys.ENTER) {
              e.preventDefault();
              const input = document.getElementsByName("initDataRef");
              if (input.length) {
                (input[0] as HTMLInputElement).focus();
              }
            }
          }}
          onChange={(e, newValue) => {
            setFormData({
              ...formData,
              dataType: newValue as string,
            });
          }}
          value={formData.dataType}
          openOnFocus
          forcePopupIcon
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              className={formClasses.formControlRoot}
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
              }}
            />
          )}
        />
      </div>
      <FormControlLabel
        label="Initialise Data (Not part of Daily Update)"
        labelPlacement="start"
        control={
          <AntSwitch
            checked={formData.initData}
            name="initDataRef"
            onClick={() =>
              setFormData({
                ...formData,
                initData: !formData.initData,
              })
            }
            onKeyDown={(e) => {
              if (e.key === Keys.ENTER) {
                e.preventDefault();
                const input = document.getElementsByName("statusRef");
                if (input.length && operation === Operation.UPDATE) {
                  (input[0] as HTMLInputElement).focus();
                }
                if (operation === Operation.CREATE) {
                  const submitBtn = document.getElementsByClassName(
                    "storybook-button storybook-button--save"
                  );
                  if (submitBtn.length) {
                    (submitBtn[0] as HTMLButtonElement).focus();
                  }
                }
              }
            }}
          />
        }
        className="items__add--form-labels"
      />
      {operation === Operation.UPDATE ? (
        <FormControlLabel
          label="Status"
          labelPlacement="start"
          control={
            <AntSwitch
              checked={formData.status}
              name="statusRef"
              onClick={() =>
                setFormData({
                  ...formData,
                  status: !formData.status,
                })
              }
              onKeyDown={(e) => {
                if (e.key === Keys.ENTER) {
                  e.preventDefault();

                  const submitBtn = document.getElementsByClassName(
                    "storybook-button storybook-button--save"
                  );
                  if (submitBtn.length) {
                    (submitBtn[0] as HTMLButtonElement).focus();
                  }
                }
              }}
            />
          }
          className="items__add--form-labels"
        />
      ) : null}

      {/* {enterDefaultData && (
        <div className="label-grid">
          <Label>Enter Default Data</Label>
          <Input />
        </div>
      )} */}
    </>
  );
};

export default Add;
